import React from 'react';
import { useLocation, createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/useStore';
import { GuardiaUscita } from './utils/uscitaProtetta';
/* PRIMA la tabella, POI il guscio nuovo (interruttore dello stile, Alex
   14/10/2026). I fogli di stile entrano nel pacchetto nell'ordine degli
   import: con la tabella per prima, le pagine, la Dashboard e il guscio di
   prima (LayoutClassico, coi suoi avvisi) hanno l'ordine che avevano nel
   638a8209, e a stile spento vince la stessa regola di allora. Il guscio
   nuovo ha i suoi fogli sotto .stile-console, che non incontrano quelli di
   prima. */
import { SCHERMATE, esitoGuardia, nelGuscio, LayoutClassico } from './navigazione/schermate';
import Layout from './components/Layout';
import { stileNuovo } from './navigazione/paginaIniziale';
import { useStileDellUtente, applicaClasseIniziale } from './navigazione/stile';
import PezzoNonCaricato, { MSG_REFERTO_NON_CARICATO } from './components/PezzoNonCaricato';
import './styles/App.css';

/* Le rotte NON si scrivono qui: stanno in navigazione/schermate.js, una
   tabella sola da cui leggono anche il menu e la barra comandi (stile
   «Console», fase 1, Alex 2/10/2026). Qui si costruiscono, e la guardia di
   ogni rotta e' esitoGuardia() della tabella: la stessa funzione a cui il
   menu chiede che cosa offrire. Una rotta nuova e' una riga della tabella.

   Il passaggio dalle <Route> scritte a mano alla tabella si e' provato col
   metodo di sempre: gli inventari (npm run rotte, npm run rotte:runtime)
   prima e dopo, zero differenze sulle rotte. */

/* Al login si arriva col posto da cui si veniva (Alex, 28/09/2026): dopo
   una sessione scaduta, entrare di nuovo riporta li', non alla pagina
   iniziale. */
const VaiAlLogin = () => {
    const l = useLocation();
    return <Navigate to="/login" replace state={{ da: `${l.pathname}${l.search}` }} />;
};

/* Una schermata con la sua guardia. Il guscio (Layout) avvolge le
   schermate del gestionale e riceve la riga della tabella: ne legge il
   percorso in alto, la voce accesa e le linguette. Il componente e' uno
   solo per tutte le rotte, quindi passando da una schermata all'altra il
   guscio resta montato e cambia solo la pagina. */
const Schermata = ({ schermata }) => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const user = useAuthStore((state) => state.user);
    const esito = esitoGuardia(schermata, user, isAuthenticated);
    if (esito.vai === '/login') return <VaiAlLogin />;
    if (esito.vai) return <Navigate to={esito.vai} replace />;
    const { Componente, props } = schermata;
    let pagina = <Componente {...props} />;
    if (schermata.attesa) {
        pagina = (
            <React.Suspense fallback={<div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>
                {schermata.attesa}</div>}>
                {pagina}
            </React.Suspense>
        );
    }
    if (!nelGuscio(schermata)) return pagina;
    /* Il guscio dello stile dell'utenza, deciso dal server
       (backend/services/stileNuovo.js): quello nuovo «Console», o quello di
       prima, senza menu scuro, Ctrl K, numeri del menu e marchio. */
    return stileNuovo(user)
        ? <Layout schermata={schermata}>{pagina}</Layout>
        : <LayoutClassico>{pagina}</LayoutClassico>;
};

/* LA PAGINA D'ERRORE DI UNA SCHERMATA CARICATA A PARTE (la «seconda
   difesa», ramo ricarica, Alex 2/10 notte). Il Referto e' l'unica rotta
   caricata a richiesta (React.lazy in navigazione/schermate.js, quella con
   `attesa`), e ha una pagina d'errore sua: se il suo pezzo di codice non
   arriva - i secondi dello scambio della build - la pagina si ricarica da
   sola una volta, con le guardie di sempre, e se non basta lo dice con
   «Ricarica», invece della pagina d'errore del router. Un errore che non e'
   un pezzo mancante arriva alla pagina del router come prima
   (components/PezzoNonCaricato.jsx; il perche' per esteso in
   utils/versioneInLinea.js, ricaricaPerPezzo).
   Con la tabella delle schermate (stile «Console») la regola si scrive una
   volta: ogni riga con `attesa` prende questo errorElement, con la stessa
   guardia e lo stesso guscio della schermata (prima era una <Route> scritta
   a mano con errorElement=<ProtectedRoute>...). Il messaggio e' della
   schermata, e i manuali lo citano alla lettera: una schermata nuova
   caricata a parte senza il suo messaggio ferma l'applicazione al
   caricamento, cioe' alla prima prova (rotte:runtime, verificaRotte), e non
   in clinica. scripts/inventarioRotte.js si ferma, dalla parte della
   tabella, su una pagina pigra senza `attesa`. */
const MESSAGGI_PEZZO = {
    '/referti/:id': MSG_REFERTO_NON_CARICATO,
};

function paginaDErrore(s) {
    const messaggio = MESSAGGI_PEZZO[s.percorso];
    if (!messaggio) {
        throw new Error(`App.js: ${s.percorso} si carica a parte e non ha il messaggio della seconda difesa (MESSAGGI_PEZZO)`);
    }
    return <Schermata schermata={{ ...s, Componente: PezzoNonCaricato, props: { messaggio, attesa: s.attesa }, attesa: null }} />;
}

/* createBrowserRouter, non BrowserRouter: dal 21 settembre 2026 il
   router e' del tipo «con dati», perche' e' l'unico su cui funziona
   useBlocker - il «vuoi uscire senza salvare» delle schermate con un
   modulo.

   Il router si costruisce UNA volta, fuori dal componente: ricostruirlo
   a ogni render di App vorrebbe dire una cronologia nuova ogni volta.

   GuardiaUscita e' l'unico blocker dell'applicazione (il router ne
   ammette uno): sta qui, sulla radice, e rende le rotte figlie. */
const router = createBrowserRouter([{
    element: <GuardiaUscita />,
    children: SCHERMATE.map((s) => ({
        path: s.percorso,
        element: <Schermata schermata={s} />,
        ...(s.attesa ? { errorElement: paginaDErrore(s) } : {}),
    })),
}]);

/* La classe dello stile su <html> prima del primo disegno, dall'utente in
   memoria: senza, la prima pagina si disegnerebbe un istante senza i fogli
   del suo guscio. */
applicaClasseIniziale();

function App() {
    /* La classe su <html> segue l'utente, e lo stile si richiede al server
       una volta all'apertura (navigazione/stile.js). */
    useStileDellUtente();
    return <RouterProvider router={router} />;
}

export default App;
